import { config } from '@uhg-abyss/web/tools/config';
import { http } from '@uhg-abyss/web/tools/http';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';
import { validationError, updateTinError } from './errors';

export const updateRegistration = async (payload) => {
  const { action } = payload;
  const response = await http({
    id: 'epv-tin-postregistration-update-tin',
    method: 'POST',
    cache: false,
    withCredentials: true,
    url: `${config('LINK_EPV_API_URL')}/registration/v1`,
    handleError: updateTinError,
    body: action.payload,
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);

  return data;
};

export const validateTin = async (payload) => {
  const { action } = payload;
  const { billingTin } = action.payload;

  const response = await http({
    id: 'epv-tin-postregistration-validate-tin',
    method: 'GET',
    cache: false,
    withCredentials: true,
    url: `${config('LINK_EPV_API_URL')}/registration/validate/v1`,
    handleError: validationError,
    query: {
      billingTin,
    },
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return {
    trackingNumber: data.trackingNumber,
    billingTin,
  };
};
